import { reactPages } from '../../r/shared/utils';

const removeBasePath = (path) => path.replace(/^\/.\//, '/');

export const getRoutePath = (pageName) => {
  const page = reactPages.find(({ title }) => title.replace(/\s+/g, '') === pageName);
  return page ? page.paths.map(removeBasePath) : '/';
};

export const getMediaPlayerUrl = (url) => {
  const players = Object.entries({
    vimeo: {
      url: `https://player.vimeo.com/video/${url.substr(url.lastIndexOf('/') + 1)}`,
      match: url.includes('vimeo.com/')
    },
    youtube: {
      url: `https://www.youtube.com/embed/${url.substr(url.indexOf('=') + 1)}`,
      match: url.includes('youtube.com/watch')
    },
    cincopa: {
      match: url.includes('www.cincopa.com'),
      url
    }
  });
  
  const playerUrl = players.reduce((url, [_, player]) => {
    if (player.match) url = player.url;
    return url
  }, '');

  return playerUrl;
};